module.exports = __webpack_public_path__ + "img/icon-fail.4577ed23.png";